import React, { useEffect } from "react";

type PropsMap = {
  isSelected?: number;
};


const Map: React.FC<PropsMap> = ({ isSelected }) => {

  useEffect(() => {
    let els = document.getElementsByClassName('active');
    if(els){
      while (els[0]) {
        els[0].classList.replace('active', 'st4')
      }
    }
    // if (isSelected) {
      document.getElementById(isSelected.toString()).children[0].classList.replace('st4', 'active')
    // }

  }, [isSelected])

  //Trouver une meilleure solution avec l'id de l'îlot selectionné dans App.tsx
  // const toggleClass = (e) => {

    // console.log(document.getElementsByClassName('st4'));
    
    // console.log(e.target.classList[0] === 'active')
    // let els = e.target.className.getElementsByClassName('active');
    // let els = document.getElementsByClassName('active');
    
    // if(els){
    //         while (els[0]) {
    //             els[0].classList.replace('active', 'st4')
    //         }
    // }
      
      // e.target.classList.replace('st4','active')
      
    
      // }
  
  return (
    <svg
      id="Calque_1"
      style={{pointerEvents: 'none'}}
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 1000 800"
      xmlSpace="preserve"
    >
      <path fill="#eaf9e8" d="M7 .7z" id="fond" />
      <g id="decor">
        <path
          className="st1"
          d="M10.9 252.2c11.7-10.3 58.6-51.7 83-77.4 0 0 61.3-50.3 113.1-43.6 0 0 44.3 6.7 67.3 32.5 0 0 20 21.4 26.6 58.4l37 182.5 9.2 72.1L363 620.4l5.2 67.3 16.3 91.6 1.5 8.1 1 5.5c.6 3.7-2.2 7-5.9 7h-13.7c-3.7 0-6.8-2.5-7.7-6l-15-60.5-13.3-130.1-20-198.8-12.8-57.5-28.8-130.8s-8.4-54.7-64.8-59.5c0 0-50.5-4.1-98.5 38.1l-66.5 68-21.2 15.6c-2 1.5-4.9.4-5.5-2L9 258.1c-.5-2.1.2-4.4 1.9-5.9z"
        />
        <path
          d="M401.3 791.1s13.6-16.9 28.1-32.5c14.1-15.2 27.2-32.1 31-52.5 8-42.7 26.1-113.5 63.4-158.6.3-.4.6-.8.9-1.3 2.8-4.5 20.5-31.3 44.3-43.1.8-.4 1.5-.8 2.2-1.4l83.6-64.7c.2-.2.5-.3.7-.5l78.6-52.7c.6-.4 1.1-.8 1.7-1.3l56.5-53.4.6-.6 57.3-62.8"
          fill="none"
          stroke="#147a09"
          strokeWidth={4}
          strokeLinecap="round"
          strokeMiterlimit={7.39}
        />
        <path
          className="st1"
          d="M41.8 268.3l37 123.4L293.1 351l-29.6-141.2s-21.4-45.1-53.2-48c0 0-47.3-5.2-89.4 28.1l-79.1 78.4zM80.4 398l57.2 179.5 186.5 13L307 409.6 295.3 354zM27.4 583.8l18.8 129.4 293 24.4-11.7-133.9zM526.5 676.2l39-78.6 94 39.3 21.6-46.2 76.8 34.5-48 105-80.2-34.8-15.4 24.6z"
        />
      </g>
      <path
        className="st3"
        d="M340.8 376.8c14.4 5.3 52.4 17.3 84.3 11 9.5-1.9 17.7-7.7 22.7-15.9 5.3-8.6 12.8-21.6 20.2-36.7.2-.3.3-.6.5-.9l43.7-71.4c.2-.3.4-.7.6-1.1 2.8-6 31.4-63.5 95.8-58.6h.1c.9 0 23.8.1 34 3.7l87.9 34.7 37.8 16.7c.4.2.9.4 1.3.7 4.5 2.7 28.8 19 7.7 37.2l-33.2 27.3c-3.1 2.5-6.7 4.5-10.5 5.7l-19.1 6.2c-.2.1-.3.1-.5.1-1.8.5-14.6 4.3-14.6 13.2 0 0-.5 10.9 1.2 19.1.5 2.6-.2 5.2-1.9 7.2-3 3.6-8.4 10.4-14.1 14.3-9.3 6.4-16.2 8.8-24.4 11.8-20 7.4-48 25.1-85 44.3 0 0-61.2 28.4-97.5 92.5-.4.7-5.9 9.5-6.7 10.9-4.2 8.4-12.8 16.4-30.2 115.6-.1.3-.1.6-.2.9l-15.4 58.1c-2.7 10.2-11.3 17.7-21.8 19-10.8 1.3-23.1-.9-26-16.2l9 52.9c.3 1.7 1.9 2.8 3.5 2.5.7-.1 1.3-.5 1.8-1l46.6-52.1c3-3.4 5.2-7.5 6.3-11.9 5.7-22.2 24.5-93.9 39.1-119.8.1-.2.3-.5.4-.7 2.6-5.5 33.8-72 57.1-85.2.5-.3 1-.6 1.5-1l91.4-70.9c.2-.1.4-.3.5-.4l77.3-53s37-27.8 45.1-36.1l25.6-27.2.6-.6c3.7-3.4 42.1-38.9 56.6-57 2.1-2.6 1.7-6.4-.9-8.5-.4-.3-.9-.6-1.3-.8L603.2 152.2c-2.4-1-5.2 0-6.2 2.4-.1.2-.2.4-.2.6l-3.1 10.5c-2.5 8.4-11.3 13.2-19.7 10.7-.6-.2-1.1-.4-1.6-.6L292.1 58.5c-2.2-.9-4.8.1-5.8 2.4-.2.4-.3.9-.3 1.4l-6.4 86.4c-2.2 12.9 1.8 18.1 7.2 25.5 5.9 8.1 13.7 23.1 18.4 49.4l28.5 144.8c.7 3.9 3.4 7.1 7.1 8.4z"
        id="For\xEAt"
      />
        {/* L'id correspond a la position de la card de l'ilot dans PostList.tsx */}
      <g id="ilots" style={{pointerEvents: 'auto'}}>
        <a id="0">
          <path
            className="st4"
            d="M300.5 94.6c-.9 1.1-13.7 21.9.3 51 1.6 3.4 4.4 6 7.9 7.5 5.9 2.4 16.5 4.3 33.8-.3 1.1-.3 2.2-.5 3.3-.6 5.5-.5 23.4-3 30.9-15.4 0 0 8.1-21.4-6.7-28.1 0 0-34.7-20-47.3-22.2-.1 0-12.6-3.7-22.2 8.1z"
          />
        </a>
        <a id="1">
          <path
            className={`st4`}
            d="M537 241c.5-.6 1-1.3 1.4-2 3.3-5.6 19.5-30.2 49.6-32.9 0 0 27.9-3.6 41.5 3.4.5.3.9.5 1.4.8 2.9 1.9 13.3 9.1 17.7 18 0 0 9.6 14.4 0 28.3 0 0-14.7 23.4-17.4 33.2-.6 2.5-1.8 4.8-3.4 6.8-3.3 4-8.9 10-15.1 13.9-.8.5-1.5 1-2.1 1.6-6.5 5.4-14.5 8.6-22.9 9.3-1 .1-2 0-3-.1-6-.7-25.9-4.5-43-24.6-.6-.7-1.2-1.3-1.9-1.9-2.8-2.4-11-10.5-11-21.2 0-.6 0-1.2-.1-1.8-.4-3.6-1.3-19.2 8.3-30.8z"
          />
        </a>
        <a id="2">
          <path
            className="st4"
            d="M675 250.4c.8-1.2 1.8-2.2 2.9-3.1 4.8-3.5 18.2-10.6 42.3-1.9 0 0 51.7 16.3 59.9 32.5 0 0 8.6 10.7-6.5 20.9-.6.4-1.2.9-1.7 1.4-4 3.9-20.4 19.5-33.8 26.8-.5.3-1 .5-1.5.7-4.2 1.6-23.7 8.7-36.1 10 0 0-37.7 3.5-57.5-5.1-2.1-.9-3.8-2.3-5.1-4.1-1.8-2.6-3-6.6-.3-12.2l19.5-35.3c.3-.6.7-1.1 1.1-1.7 2.3-3 10.9-14.3 13.1-22 .4-1.2.9-2.4 1.6-3.5l2.1-3.4z"
          />
        </a>
        <a id="3">
          <path
            className="st4"
            d="M507.2 405.5c10.1-3.8 18.6-7.9 18.6-7.9 2.7-1 5.3-3.6 7.3-6.1 1.9-2.6 3.4-5.3 4.7-8.2 2.7-6.6 8.9-14.2 14.3-20.1 7.9-8.6 9.3-21.3 3.2-31.3-.1-.1-.2-.3-.3-.4-3.4-5.4-8-9.9-13.4-13.2-7.9-4.8-9.6-6.4-13.7-9.4-2.3-1.5-4.8-2.5-7.5-2.9-12.3-1.2-26.1 4.3-29.8 8-5 5.1-11.3 15.5-12.1 16.5-8.2 11.4-11.9 14.9-12.7 15.7-.2.2-.4.4-.7.6l-2.5 2.5c-5.5 7-7.1 12.5-9.1 19.6-2.5 9.1-6.6 17.8-12.1 25.5-3 4.3-6.2 8.4-9.7 12.3-2 2.1-2.5 5.3-1.1 7.9 1.8 3.1 4.2 5.9 7 8.2.6.5 1.4 1 2.2 1.2 12.4 4.3 33.6-4 39.5-6.4 3-1.2 7-2.6 11.1-4.4l16.8-7.7z"
          />
        </a>
        <a id="4">
          <path
            className="st4"
            d="M563.6 410.2l5.2-34.7s9.6-22.9 23.6-28.8c0 0 9.6-5.9 46.6 2.2 0 0 17 6.7 33.3 3 0 0 15.5-3 23.6 3.7 0 0 8.1 8.1 2.2 15.5 0 0-5.3 7.9-21.4 15.6-1.8.8-3.4 1.8-5.1 2.9-6.7 4.4-14.2 7.2-22.1 8.4 0 0-37.1 10-44.5 20.3 0 0-14.8 14-29.6 14 0 0-11.8-4.4-11.8-22.1z"
          />
        </a>
        <a id="5">
          <path
            className="st4"
            d="M432 458.9s15.5-18.5 53.9-31c0 0 16.3-5.9 22.9-10.3 0 0 14.8-10.3 28.1-7.4l16.5 15.2s9.4 9.2 4.2 23.2c0 0-5.2 10.3-21.4 15.5 0 0-20.7 11.8-30.3 26.6 0 0-12.6 28.8-22.2 30.3 0 0-17 8.1-28.1-3.7 0 0-22.2-15.5-31-34 0 0-2.2-15.5 7.4-24.4z"
          />
        </a>
        <a id="6">
          <path
            className="st4"
            d="M394.3 476.7s34 28.1 45.1 47.3c0 0 16.3 20.7 17 37 0 0 0 11.1-15.5 14.8 0 0-23.6 5.2-31.8 4.4 0 0-9.6 0-11.8-12.6l-7.4-79.1s.7-8.1 4.4-11.8z"
          />
        </a>
        <a id="7">
          <path
            className="st4"
            d="M401 598.6l1.5 47.3s2.2 37.7 4.4 43.6c0 0 2.2 7.4 3.7 5.9 0 0 5.2-1.5 7.4-10.3l20-52.5 11.1-37s2.2-11.1-4.4-11.8l-34.7 3.7c-.2 0-6.8.8-9 11.1z"
          />
        </a>
      </g>
      <g id="Chemin" fill="none" strokeMiterlimit={7.39}>
        <path
          id="Terrain"
          d="M286 62.2l-6.9 92.4c-.5 6.1 1.5 12.2 5.5 16.9 6.9 8.1 17.5 25.9 21.8 60.5l34 170 16.3 132.3L370 681.4l16.8 98.4c.3 1.5 1.7 2.6 3.3 2.3.6-.1 1.2-.4 1.6-.9l48.3-54.1c2.1-2.3 3.5-5.1 4.1-8.1 4.1-19.2 21.6-94.8 55.2-152.5.6-1.1 9.4-15.9 10-17 7.9-15.3 19.1-28.5 32.9-38.8l92.4-71.7 77.6-53.2s46.2-33.6 70.9-63.6l35.6-33.4 1.2-1.2 20.5-24.1c1.7-2 1.4-4.9-.5-6.6-.3-.3-.7-.5-1.1-.7L602.8 152c-2.1-.9-4.6 0-5.5 2.1-.1.2-.1.3-.2.5l-6.8 23c-.7 2.4-3.3 3.8-5.7 3.1-.2 0-.3-.1-.5-.2L292 58.5c-2.2-.9-4.8.1-5.7 2.3-.2.5-.3.9-.3 1.4z"
          stroke="#8ec871"
          strokeWidth={0.739}
        />
        <path
          d="M328.5 410.9s17.7.7 18.5-3c.6-2.9-.7-22.2-1.2-30.4-.2-2.9.5-5.8 2.1-8.3 2.5-4 7.4-9.6 16.3-13.6.3-.1.6-.3.9-.4 3.5-1.3 28.8-11.3 24-36.8 0 0-2.2-20-24.4-33.3 0 0-12.6-7.4-15.5-20.7l-10.8-36.7c-.2-.6-.4-1.2-.7-1.8-2.1-4.5-11.5-25.7-10.1-34.7.1-.5.2-1 .4-1.4 1.2-3.8 7.1-20.4 22.7-29.5 0 0 5.2-3.7 19.2-3.7l22.8.6c3.4.1 6.7 1.5 9.2 3.9 3 3 6.6 8 8.5 16.4.1.3.2.6.3 1l11.1 35.9c.6 2.1 1.8 4.1 3.4 5.7 3.8 3.8 12 8.6 27.5 5.2l22.8-5.5c1-.2 2.1-.4 3.1-.4 4.2 0 15.9-.3 23.9-1.4 2.4-.3 4.6-1.3 6.5-2.8 3.1-2.4 8.6-6.1 13.1-6.1 6.7 0 14.8 0 20-4.4 5.2-4.4 14-13.3 25.9-11.8s28.8-3 32.5-8.1c3.6-5.1 26-2.3 40.1 2 .4.1.7.2 1.1.4l25.3 10.1s10.8 3.9 18.3 9.1c6.2 4.3 7.8 12.8 3.6 19.1-.1.2-.2.3-.3.5-.4.5-.9 1.1-1.4 1.7-2.6 2.9-6.3 4.6-10.2 4.6-15.9 0-55-1.6-55-1.6l-23.5-2.1c-1.2-.1-2.3-.1-3.5.1-5.9 1-23.4 5.1-12.9 17.5 0 0 10.1 11.5 30.3 16.1.5.1 1 .3 1.5.4l60.1 21.2s30.1 9.4 53.7-.4c.5-.2 1-.5 1.5-.8l28.7-16.4c1-.6 2-1.3 2.8-2.1 2.6-2.5 9-8.5 15.3-11.9 4.2-2.2 9.2-2.1 13.3.3l11.4 6.6c2.7 1.5 4.8 4 5.9 6.9 2 5.3 3 14.2-6.8 23.3-.3.3-.6.6-.8.9l-17.6 19.6c-1.2 1.4-2.7 2.4-4.3 3.2-2.9 1.3-6.1 2-9.3 1.9-1.4 0-2.8.2-4.2.5-5 1.4-16.2 5.8-21.9 17.1 0 0-4 6.2-4 17.7 0 3.5-1.3 7-3.8 9.5-3.1 3.2-5.7 5.8-7.6 7.5-1.6 1.5-3.5 2.6-5.6 3.2-6.2 1.8-20.2 5.3-28.6 4.2-11.1-1.5-67.3 8.9-89.4 3-19.5-5.2-63.6-17.3-73.9-20.1-1.8-.5-3.8-.6-5.7-.3-5.4.8-15.6 4.2-18.4 17.8-.2 1.2-.3 2.4-.2 3.6.4 4.9 1.8 19.1 7.3 32 .5 1.2.8 2.4 1 3.6l2.6 18.6.3 1.5c.6 2.3 1.9 11.3-8.7 22.2-2.5 2.5-5.8 4-9.4 4.1-6.3.2-16.6-1.8-27-13.9-.7-.8-1.6-1.6-2.5-2.2l-23.3-16.2c-1.1-.8-2.1-1.7-2.9-2.8-2.9-3.6-11.2-12.4-21.8-8.8 0 0-13.3 2.2-21.4 21.4 0 0-4.2 9.1-3.4 17.9.1 1.5.5 3 1.2 4.3 1.7 3.7 5.6 13 4.4 17.7 0 0-1.3 13.4 2.3 25.5.3 1.1.8 2.2 1.5 3.2l12.6 20.6c.4.7.8 1.4 1 2.1 1.7 4.2 7.8 19.7 8.4 24.8l2.1 16.9c.1.5.1 1.1.1 1.6l.7 82.7c0 1-.1 2-.3 2.9-.9 4.1-3.3 16.3-3.5 21.3-.1 1.4-.3 2.8-.8 4.1l-9.4 25.6-6.1 16.4c-.4 1-.9 2-1.5 2.9-2 2.9-6.7 8.8-12.3 8.8 0 0-12.1 0-14.6-14.6-.1-.6-.2-1.2-.4-1.7-.8-2.8-3.6-12.5-4.2-20.6l-3-47.3L350.7 422s0-11.8-22.2-11.1z"
          stroke="#000"
          strokeWidth={3.695}
        />
      </g>
      <g id="Objets">
        <circle cx={421.7} cy={431.6} r={7.4} fill="#5ab6e8" />
        <path
          transform="rotate(-45.001 376.208 401.67)"
          fill="red"
          d="M370.7 396.1h11.1v11.1h-11.1z"
        />
        <path
          opacity={0.99}
          fill="none"
          stroke="red"
          strokeWidth={2.217}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={2.956}
          d="M626.7 205.8l15.2-10.7 13.6 5.1 1.9 17.8"
        />
        <path
          className="st11"
          d="M459 203.6l11.8-8.1M461.2 194l8.1 11.1"
        />
        <path
          className="st3"
          d="M361.3 442.4l24.6 272.3c.2 1.9 1.9 3.4 3.8 3.2h.1l11.5-1.4c1.9-.2 3.2-1.9 3.1-3.8l-21.3-272.5c-.2-1.9-1.8-3.4-3.8-3.2h-.1l-14.8 1.6c-1.9.2-3.3 1.9-3.1 3.8z"
        />
      </g>
    </svg>
  );
}

export default Map;

